import React from 'react'
import { Heading, List } from 'lib/ui'
import Link from 'lib/components/Link'

const About = ({}) => {
  return (
    <>
      <Heading inverted as="h4" content="About" />
      <List link inverted>
        <Link href="/faq" passHref>
          <List.Item as="a">Contact Us</List.Item>
        </Link>
        <Link href="/faq" passHref>
          <List.Item as="a">FAQ</List.Item>
        </Link>
        <Link href="/terms" passHref>
          <List.Item as="a">Terms</List.Item>
        </Link>
        <Link href="/privacy" passHref>
          <List.Item as="a">Privacy</List.Item>
        </Link>
      </List>
    </>
  )
}

export default About
